export enum ThirdPartyLoginProvider {
  Apple = "apple",
  Facebook = "facebook",
  Google = "google",
}
